// Keep swatches and labels aligned with cs-client-portal/src/entities/events/oneOff.ts.
export type TBrickColor = {
  background: string;
  label: string;
  text: string;
  value: string;
};

// Swatches approximate the supplied brick reference photo; lighting and metallic finish affect appearance.
// Keep existing stored values (blue, red, green, gold, silver) while using the catalog labels.
export const BRICK_COLOR_CATALOG: Record<string, TBrickColor> = {
  gold: { background: '#88722f', label: 'Metallic Gold', text: '#ffffff', value: 'gold' },
  silver: { background: '#77716d', label: 'Metallic Silver', text: '#ffffff', value: 'silver' },
  redBrown: { background: '#54200d', label: 'Red Brown', text: '#ffffff', value: 'redBrown' },
  darkTan: { background: '#806b3e', label: 'Dark Tan', text: '#ffffff', value: 'darkTan' },
  lightTan: { background: '#b9a76c', label: 'Light Tan', text: '#111111', value: 'lightTan' },
  coral: { background: '#e65d36', label: 'Coral', text: '#ffffff', value: 'coral' },
  pink: { background: '#bc83a0', label: 'Pink', text: '#ffffff', value: 'pink' },
  newDarkRed: { background: '#650908', label: 'New Dark Red', text: '#ffffff', value: 'newDarkRed' },
  red: { background: '#bc1709', label: 'Bright Red', text: '#ffffff', value: 'red' },
  brightOrange: { background: '#ed7a08', label: 'Bright Orange', text: '#ffffff', value: 'brightOrange' },
  brightLightOrange: { background: '#e7a91a', label: 'Bright Light Orange', text: '#111111', value: 'brightLightOrange' },
  yellow: { background: '#dec12c', label: 'Yellow', text: '#111111', value: 'yellow' },
  lime: { background: '#8ea92d', label: 'Lime', text: '#111111', value: 'lime' },
  brightGreen: { background: '#16954d', label: 'Bright Green', text: '#ffffff', value: 'brightGreen' },
  green: { background: '#075e3d', label: 'Dark Green', text: '#ffffff', value: 'green' },
  earthGreen: { background: '#102d24', label: 'Earth Green', text: '#ffffff', value: 'earthGreen' },
  brightBluegreen: { background: '#08768a', label: 'Bright Bluegreen', text: '#ffffff', value: 'brightBluegreen' },
  mediumAzure: { background: '#459eb8', label: 'Medium Azure', text: '#ffffff', value: 'mediumAzure' },
  darkAzure: { background: '#147da8', label: 'Dark Azure', text: '#ffffff', value: 'darkAzure' },
  mediumBlue: { background: '#588fa7', label: 'Medium Blue', text: '#ffffff', value: 'mediumBlue' },
  blue: { background: '#073799', label: 'Bright Blue', text: '#ffffff', value: 'blue' },
  earthBlue: { background: '#142037', label: 'Earth Blue', text: '#ffffff', value: 'earthBlue' },
  purple: { background: '#39205c', label: 'Purple', text: '#ffffff', value: 'purple' },
  lavender: { background: '#9461a2', label: 'Lavender', text: '#ffffff', value: 'lavender' },
  black: { background: '#181814', label: 'Black', text: '#ffffff', value: 'black' },
  darkGray: { background: '#555653', label: 'Dark Gray', text: '#ffffff', value: 'darkGray' },
  lightGray: { background: '#92958f', label: 'Light Gray', text: '#111111', value: 'lightGray' },
  white: { background: '#e5e2d9', label: 'White', text: '#111111', value: 'white' }
};
